import styled from 'styled-components';

export const StyledStack = styled.div<{
  direction?: { lg?: string; md?: string; xs?: string } | string | any;
  columnGap?: { lg?: string; md?: string; xs?: string } | string | any;
  rowGap?: { lg?: string; md?: string; xs?: string } | string | any;
  padding?:
    | string
    | any
    | {
        lg?: string;
        md?: string;
        xs?: string;
      };
  margin?:
    | {
        lg?: string;
        md?: string;
        xs?: string;
      }
    | string
    | any;
  justifyContent?: { lg?: string; md?: string; xs?: string } | string | any;
  alignItem?: { lg?: string; md?: string; xs?: string } | string | any;
  height?: { lg?: string; md?: string; xs?: string } | string | any;
  minHeight?: { lg?: string; md?: string; xs?: string } | string | any;
  width?: { lg?: string; md?: string; xs?: string } | string | any;
  display?: { lg?: string; md?: string; xs?: string } | string | any;
}>`
  width: ${props => props?.width?.lg || props?.width || '100%'};
  height: ${props => props?.height?.lg || props?.height || 'unset'};
  min-height: ${props => props?.minHeight?.lg || props?.minHeight || 'unset'};
  display: ${props => props?.display?.lg || props?.display || 'flex'};
  flex-direction: ${props => props?.direction?.lg || props?.direction || 'row'};
  column-gap: ${props => props.columnGap?.lg || props?.columnGap || '0'};
  row-gap: ${props => props.rowGap?.lg || props?.rowGap || '0'};
  padding: ${props => props.padding?.lg || props?.padding || '0'};
  margin: ${props => props.margin?.lg || props?.margin || '0'};
  justify-content: ${props =>
    props?.justifyContent?.lg || props?.justifyContent || 'start'};
  align-items: ${props => props?.alignItem?.lg || props?.alignItem || 'start'};
  @media (max-width: 1200px) {
    display: ${props =>
      props?.display?.md || props?.display?.lg || props?.display || 'flex'};
    width: ${props =>
      props?.width?.md || props?.width?.lg || props?.width || '100%'};
    height: ${props =>
      props?.height?.md || props?.height?.lg || props?.height || 'unset'};
    min-height: ${props =>
      props?.height?.md || props?.minHeight?.lg || props?.minHeight || 'unset'};
    flex-direction: ${props =>
      props?.direction?.md || props.direction?.lg || props?.direction || 'row'};
    column-gap: ${props =>
      props.columnGap?.md || props.columnGap?.lg || props?.columnGap || '0'};
    row-gap: ${props =>
      props.rowGap?.md || props.rowGap?.lg || props?.rowGap || '0'};
    padding: ${props =>
      props.padding?.md || props.padding?.lg || props?.padding || '0'};
    margin: ${props =>
      props.margin?.md || props.margin?.lg || props?.margin || '0'};
    justify-content: ${props =>
      props?.justifyContent?.md ||
      props?.justifyContent?.lg ||
      props?.justifyContent ||
      'start'};
    align-items: ${props =>
      props?.alignItem?.md ||
      props?.alignItem?.lg ||
      props?.alignItem ||
      'start'};
  }
  @media (max-width: 540px) {
    width: ${props =>
      props?.width?.xs || props?.width?.md || props?.width || '100%'};
    height: ${props =>
      props?.height?.xs || props?.height?.md || props?.height || 'unset'};
    min-height: ${props =>
      props?.minHeight?.xs ||
      props?.minHeight?.md ||
      props?.minHeight ||
      'unset'};
    display: ${props =>
      props?.display?.xs || props?.display?.md || props?.display || 'flex'};
    flex-direction: ${props =>
      props?.direction?.xs ||
      props?.direction?.md ||
      props?.direction ||
      'row'};
    column-gap: ${props =>
      props.columnGap?.xs || props?.columnGap?.md || props?.columnGap || '0'};
    row-gap: ${props =>
      props.rowGap?.xs || props?.rowGap?.md || props?.rowGap || '0'};
    padding: ${props =>
      props.padding?.xs || props?.padding?.md || props?.padding || '0'};
    margin: ${props =>
      props.margin?.xs || props?.margin?.md || props?.margin || '0'};
    justify-content: ${props =>
      props?.justifyContent?.xs ||
      props?.justifyContent?.md ||
      props?.justifyContent ||
      'start'};
    align-items: ${props =>
      props?.alignItem?.xs ||
      props?.alignItem?.md ||
      props?.alignItem ||
      'start'};
  }
`;
